import React, { useEffect, useMemo, useState } from "react";
import { Container, Row, Col, Card, Badge } from "react-bootstrap";
import api from "common/api";
import { ITeacher } from "common/types";
import { s3_url } from "common/constants";
import Spinner from "../../spinner";
import usePageTitle from "common/usePageTitle";
import LumenButton from "../../ui/LumenButton";
import LumenNavbar from "../../layout/LumenNavbar";
import NewFooter from "../../layout/NewFooter";
import "./NewTeachersPage.css";

const PREPARATION_STATIC_TEACHERS: any[] = [
  {
    user_id: -1,
    first_name: "Karmen",
    last_name: "Dasović",
    profile: {
      title: "mag.educ.",
      picture:
        "https://awesome-lumen-web-2-31.s3.amazonaws.com/teachers/Karmen.webp",
      remark:
        "Karmen je magistra edukacije matematike i fizike, diplomu je stekla na Pedagoškom fakultetu u Rijeci. Svoju ljubav prema matematici i fizici pokazuje svakodnevno pomažući učenicima u savladavanju nastavnih sadržaja u školi za poduke Lumen, čija je i vlasnica. Karmen je veoma strpljiva i smirena i uvijek nasmijana te je uz njezinu podršku učenje nastavnih sadržaja zaista lako. Za vas je osmislila i nešto novo, platformu za učenje Lumen@home.",
    },
  },
  {
    user_id: -2,
    first_name: "Mia",
    last_name: "Černivec",
    profile: {
      title: "mag.educ.",
      picture:
        "https://awesome-lumen-web-2-31.s3.amazonaws.com/teachers/Mia.webp",
      remark:
        "Mia je magistra edukacije matematike i informatike. Diplomirala je na Odjelu za matematiku, Sveučilišta u Rijeci, a trenutno radi kao profesorica u Medicinskoj školi u Rijeci. Matematika je njezina ljubav i uvijek će se potruditi nastavne sadržaje objasniti vam na zanimljiv način koji će vam ostati dugooo u pamćenju. Uspješno je pripremila mnoge generacije za ispit državne mature iz matematike i iz te se učionice Lumenom uvijek ori smijeh.",
    },
  },
  {
    user_id: -3,
    first_name: "Maria",
    last_name: "Juretić Mohorić",
    profile: {
      title: "dipl. biokemičarka",
      picture:
        "https://awesome-lumen-web-2-31.s3.amazonaws.com/teachers/Maria.webp",
      remark:
        "Maria je nastavnica kemije u Medicinskoj školi u Rijeci, a svoju diplomu diplomirane biokemičarke stekla je na Sveučilištu u Ljubljani. Njezina su predavanja jednostavna, pregledna i posložena kako bi riješila sve vaše nedoumice za nastavne sadržaje kemije. Plus je što je Maria uvijek nasmijana i najteži kemijski problem uz njezina predavanja postat će jednostavan i jasan.",
    },
  },
  {
    user_id: -4,
    first_name: "Eliza",
    last_name: "Fućak",
    profile: {
      title: "univ.mag.",
      picture:
        "https://awesome-lumen-web-2-31.s3.amazonaws.com/img/nastavnici/Eliza.webp",
      remark:
        "Eliza je molekularni biolog, a svoju diplomu stekla je na zagrebačkom PMF-u. Biologiju je odabrala jer voli promatrati i razumjeti svijet oko sebe te učiti o njemu. Lako će vas zainteresirati za prirodni svijet koji je pun nevjerojatnih bića i priča čiji su oni glavni likovi. Na pripremama očekujte zanimljivu, radnu i veselu atmosferu.",
    },
  },
  {
    user_id: -5,
    first_name: "Ana",
    last_name: "Kramarić",
    profile: {
      title: "mag.educ.",
      picture:
        "https://awesome-lumen-web-2-31.s3.amazonaws.com/img/nastavnici/Ana.webp",
      remark:
        "Naša Ana profesorica je hrvatskog i njemačkog jezika i književnosti. Diplomirala je na Filozofskom fakultetu u Rijeci. Iskustvo u poučavanju stekla je radeći kao učiteljica hrvatske nastave u inozemstvu te kao predavačica njemačkog jezika i hrvatskog jezika kao stranog jezika u školama stranih jezika. Ana ima mnoštvo zanimljivih hobija i na njezinim podukama sigurno vam neće biti dosadno.",
    },
  },
  {
    user_id: -6,
    first_name: "Igor",
    last_name: "Lisac",
    profile: {
      title: "mag.phys.",
      picture:
        "https://awesome-lumen-web-2-31.s3.amazonaws.com/img/nastavnici/Igor.webp",
      remark:
        "Igor je profesor fizike poznat po tome što složene pojave objašnjava na jednostavan i zanimljiv način, povezujući teoriju sa svakodnevnim životom. Njegova predavanja potiču učenike na razmišljanje, istraživanje i postavljanje pitanja, čime razvija znatiželju i kritičko mišljenje.",
    },
  },
];

const NewTeacherPage: React.FC = () => {
  const [teachers, setTeachers] = useState<ITeacher[]>([]);
  const [loading, setLoading] = useState(false);

  usePageTitle("Nastavnici");

  useEffect(() => {
    const fetchTeachers = async () => {
      setLoading(true);
      try {
        const response = await api.get("/teachers/");
        setTeachers(response.data || []);
      } catch (e) {
        console.error("Error fetching teachers", e);
      } finally {
        setLoading(false);
      }
    };
    fetchTeachers();
  }, []);

  const lessonTeachers = useMemo(
    () =>
      teachers.filter(
        (t: any) =>
          t.lesson_profile &&
          !t.lesson_profile.hidden &&
          Array.isArray(t.lesson_profile.subjects) &&
          t.lesson_profile.subjects.length > 0,
      ),
    [teachers],
  );

  if (loading) {
    return <Spinner />;
  }

  return (
    <>
      <LumenNavbar />
      <div className="teachers-page">
        <div className="bg-circle small mid-left" />
        <div className="bg-circle small bottom-left" />

        <section className="tp-hero">
          <Container>
            <Row className="align-items-center">
              <Col lg={6} className="text-center">
                <h1 className="tp-eyebrow">NASTAVNICI</h1>
                <p className="tp-subtitle">Stručni i pouzdani</p>
              </Col>
              <Col lg={6} className="text-center">
                <div className="tp-mascot-wrap">
                  <img
                    className="tp-mascot"
                    src={`${s3_url}/nastavnici/lumenko-poduke.webp`}
                    alt="Lumenko"
                    loading="lazy"
                  />
                </div>
              </Col>
            </Row>

            <div className="tp-lead-below">
              <p className="tp-lead">
                Naši nastavnici su dokazani stručnjaci s bogatim iskustvom u
                poučavanju učenika različitih uzrasta. Uz stručne materijale,
                odlikuje ih predanost, strpljenje te sposobnost prilagođavanja
                nastavnih sadržaja na način koji učenicima olakšava učenje i
                potiče motivaciju.
              </p>
            </div>
          </Container>
        </section>

        <section className="tp-preps">
          <Container>
            <h2 className="tp-section-title text-center">PRIPREME ZA MATURU</h2>

            <div className="tp-preps-panel gradient rounded-4">
              <Row className="g-4 justify-content-center">
                {PREPARATION_STATIC_TEACHERS.map((t) => {
                  const profile: any = t.profile;
                  const img =
                    profile?.picture || `${s3_url}/img/lumenko/lumenko.webp`;
                  const fullName = `${t.first_name ?? ""}${
                    t.last_name ? " " + t.last_name : ""
                  }`;
                  const title = profile?.title;
                  const remark = profile?.remark;

                  return (
                    <Col key={t.user_id} xs={12} sm={6} md={4} lg={4}>
                      <div className="tp-prep-card text-center">
                        <img
                          src={img}
                          alt={fullName}
                          className="tp-prep-photo"
                          loading="lazy"
                        />
                        <div className="tp-prep-name">{fullName}</div>
                        {title && <div className="tp-prep-title">{title}</div>}
                        {remark && <p className="tp-prep-remark">{remark}</p>}
                      </div>
                    </Col>
                  );
                })}
              </Row>

              <div className="text-center mt-4">
                <LumenButton
                  to="/prijava-pripreme-drzavna-matura"
                  className="tp-cta tp-cta-outline"
                >
                  PRIJAVI SE
                </LumenButton>
              </div>
            </div>
          </Container>
        </section>

        <section className="tp-lessons">
          <div className="bg-circle lessons-decor left" />
          <div className="bg-circle lessons-decor right" />

          <Container>
            <h2 className="tp-section-title text-center">PODUKE</h2>

            <div className="tp-lessons-panel gradient rounded-4">
              <Row className="g-5 justify-content-center">
                {lessonTeachers.map((t) => {
                  const lp: any = (t as any).lesson_profile;
                  const img =
                    lp?.picture || `${s3_url}/img/lumenko/lumenko.webp`;
                  const name = t.first_name || "";

                  return (
                    <Col key={t.user_id} md={6} lg={4} xl={3}>
                      <Card className="tp-lesson-card h-100">
                        <div className="text-center pt-3">
                          <img
                            src={img}
                            alt={name}
                            className="tp-lesson-photo"
                            loading="lazy"
                          />
                        </div>
                        <Card.Body className="text-center">
                          <h3 className="tp-lesson-name">{name}</h3>

                          {lp?.subjects?.length > 0 && (
                            <div className="mb-2">
                              {lp.subjects.map((s: any, idx: number) => (
                                <Badge
                                  key={idx}
                                  bg="primary"
                                  className="tp-badge me-2 mb-2"
                                >
                                  {s.name}
                                </Badge>
                              ))}
                            </div>
                          )}

                          {lp?.remark && (
                            <p className="tp-lesson-remark">{lp.remark}</p>
                          )}
                        </Card.Body>
                      </Card>
                    </Col>
                  );
                })}
              </Row>

              <div className="text-center mt-5">
                <LumenButton
                  to="/poduke/rezervacija"
                  className="tp-cta tp-cta-outline"
                >
                  PRIJAVI SE
                </LumenButton>
              </div>
            </div>
          </Container>
        </section>
      </div>
      <NewFooter />
    </>
  );
};

export default NewTeacherPage;
